/**
 * External Dependencies
 */
import { gsap, Power2, ScrollTrigger } from 'gsap/all';
import isotope from 'isotope-layout/dist/isotope.pkgd.min';
import 'jquery';
import 'lity';
import lozad from 'lozad';
import slick from 'slick-carousel';
import { WOW } from 'wowjs';

$(() => {
  // console.log('Hello world');
  var wow = new WOW({
    live: false,
  });
  wow.init();

  const observer = lozad();
  observer.observe();

  gsap.install(window);

  gsap.registerPlugin(ScrollTrigger);

  /** Image animation **/
  if ($('.revealedBox').length) {
    $('.revealedBox').each(function (i) {
      var childrenSpan = $(this).children('span').length;
      $(this).addClass('childrenSpan-' + childrenSpan);
      if (
        $(window).scrollTop() + $(window).height() >
        $(this).offset().top + $(this).outerHeight()
      ) {
        $(this).addClass('revealedBox-in');
      }
    });

    $(window).scroll(function () {
      $('.revealedBox').each(function (i) {
        if ($(window).scrollTop() + $(window).height() > $(this).offset().top) {
          $(this).addClass('revealedBox-in');
        }
      });
    });
  }

  if ($('[data-slick]').length) {
    $('[data-slick]').slick({});
    $('.slick-next,.slick-prev,.slick-arrow').click(function () {
      $('.slick-slider .full-banner-heading').one(
        'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
        function (e) {
          $('.slick-slider .full-banner-heading').removeClass(
            'animated fadeInUp'
          );
        }
      );
      $('.slick-slider .full-banner-heading')
        .removeClass('animated fadeInUp')
        .addClass('animated fadeInUp');
    });
  }

  function menuOpen() {
    $('body').addClass('menu-open');
    $('.hamburger').addClass('active');
    $('.navbar-nav').addClass('menuhide');
  }
  function menuClose() {
    $('body').removeClass('menu-open');
    $('.hamburger').removeClass('active');
    $('.navbar-nav').removeClass('menuhide');
  }
  let t1 = gsap.timeline({
    paused: true,
    onStart: menuOpen,
    onReverseComplete: menuClose,
  });
  t1.to('.nav-container', {
    duration: 0.8,
    clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
    right: 0,
    ease: 'Power3.InOut',
  });
  t1.from(
    '.main-nav__col  ',
    {
      stagger: 0.05,
      opacity: 0,
      y: 20,
      ease: 'Power3.InOut',
    },
    '-=0'
  );
  t1.reverse();

  $('.menu-open-test').on('click', function () {
    t1.reversed(!t1.reversed());
  });

  /* Tabs */
  if ($('.tabs').length) {
    $('ul.tabs li').click(function () {
      var $this = $(this);
      var $theTab = $(this).attr('id');
      if ($this.hasClass('active')) {
        // Do Nothing
      } else {
        $this
          .closest('.tabs_wrapper')
          .find('ul.tabs li, .tabs_container .tab_content')
          .removeClass('active');
        $(
          '.tabs_container .tab_content[data-tab="' +
            $theTab +
            '"], ul.tabs li[id="' +
            $theTab +
            '"]'
        ).addClass('active');
      }
    });
  }

  if ($('.gallery').length) {
    $('ul.tabs li').click(function () {
      var $this = $(this);
      var $theTab = $(this).attr('id');
      if ($this.hasClass('active')) {
        // Do Nothing
        // alert('false')
        // $('.tabs_container .tab_content[data-tab="' + $theTab + '"]').find('.grid-gallery').addClass('wow');
        $('.tabs_container .tab_content[data-tab="' + $theTab + '"]')
          .find('.grid-gallery .grid-gallery-item')
          .addClass('animated');
        $('.tabs_container .tab_content[data-tab="' + $theTab + '"]')
          .find('.grid-gallery .grid-gallery-item')
          .attr('style', 'visibility: visible; animation-name: fadeInUp;');
      } else {
        // $this.closest('.tabs_wrapper').find('ul.tabs li, .tabs_container .tab_content').removeClass('active');
      }
    });
  }

  // Faq
  $('.accordion .panel-heading').click(function () {
    $(this).siblings('.panel-collapse').slideToggle();
    $(this).find('i').toggleClass('fa-plus fa-minus');
  });

  if ($('img.svg-icon').length) {
    $(function () {
      $('img.svg-icon').each(function () {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(
          imgURL,
          function (data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
              $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
              $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Check if the viewport is set, else we gonna set it if we can.
            if (
              !$svg.attr('viewBox') &&
              $svg.attr('height') &&
              $svg.attr('width')
            ) {
              $svg.attr(
                'viewBox',
                '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width')
              );
            }

            // Replace image with new SVG
            $img.replaceWith($svg);
          },
          'xml'
        );
      });
    });
  }

  /* Camp slider */
  if ($('.camp-slider').length) {
    var horizontalSections = gsap.utils.toArray('.horizontal-slider');
    horizontalSections.forEach(function (sec, i) {
      var thisPinWrap = sec.querySelector('.pin-wrap');
      var thisAnimWrap = thisPinWrap.querySelector('.camp-slider');

      var getToValue = () => -(thisAnimWrap.scrollWidth - window.innerWidth);

      gsap.fromTo(
        thisAnimWrap,
        {
          x: () =>
            thisAnimWrap.classList.contains('camp-slider') ? 0 : getToValue(),
        },
        {
          x: () =>
            thisAnimWrap.classList.contains('camp-slider') ? getToValue() : 0,
          ease: 'none',
          scrollTrigger: {
            trigger: sec,
            start: 'top top',
            end: () => '+=' + thisAnimWrap.scrollWidth,
            pin: thisPinWrap,
            invalidateOnRefresh: true,
            //anticipatePin: 1,
            scrub: true,
            //markers: true,
          },
        }
      );
    });
  }

  if ($('.play-in-lightbox').length) {
    // open lightbox
    document.querySelectorAll('.play-in-lightbox').forEach((videoBtn) => {
      console.log('video lightbox js working');
      videoBtn.onclick = () => {
        console.log('video lightbox js fired on click');
        const video = document.querySelector('.video-lightbox video');
        const videoLightbox = document.querySelector('.video-lightbox');
        const videoClose = document.querySelector('.video-lightbox__close');

        // set video src
        video.src = videoBtn
          .querySelector(`.video-src`)
          .getAttribute('data-src');

        // show lightbox
        videoLightbox.style.display = 'block';
        setTimeout(function () {
          videoLightbox.style.opacity = '100%';
        }, 10);
        setTimeout(function () {
          video.style.opacity = '100%';
          video.style.transform = 'scale(1,1)';
        }, 140);
        setTimeout(function () {
          videoClose.style.opacity = '100%';
          videoClose.style.transform = 'translateX(0)';
        }, 350);

        video.play();
      };
    });

    // close lightbox
    document.querySelector('.video-lightbox .video-lightbox__inner').onclick =
      () => {
        const video = document.querySelector('.video-lightbox video');
        const videoLightbox = document.querySelector('.video-lightbox');
        document.querySelector('.video-lightbox');

        // hide lightbox
        setTimeout(function () {
          video.style.opacity = '0';
          video.style.transform = 'scale(0.9,0.9)';
        }, 200);
        setTimeout(function () {
          videoLightbox.style.opacity = '0';
        }, 300);
        setTimeout(function () {
          videoLightbox.style.display = 'none';
        }, 600);

        video.pause();
      };
  }

  /* Isotop animation */
  if ($('.filters').length) {
    // init Isotope
    var $container = $('.image-grid').isotope({
      itemSelector: '.image-grid-item',
      layoutMode: 'fitRows',
      hiddenStyle: {
        opacity: 0,
      },
      visibleStyle: {
        opacity: 1,
      },
    });

    // filter functions
    var filterFns = {
      // show if number is greater than 20
      numberGreaterThan50: function () {
        var number = $(this).find('.number').text();
        return parseInt(number, 10) > 20;
      },
      // show if name ends with -ium
      ium: function () {
        var name = $(this).find('.name').text();
        return name.match(/ium$/);
      },
    };

    // bind filter button click
    $('.filter-button-group').on('click', 'li', function () {
      var filterValue = $(this).attr('data-filter');
      // use filterFn if matches value
      filterValue = filterFns[filterValue] || filterValue;
      $container.isotope({
        filter: filterValue,
      });
      $('.filter-button-group li').removeClass('active');
      $(this).addClass('active');
    });

    // change is-checked class on buttons
    $('.filter-button-group').each(function (i, buttonGroup) {
      var $buttonGroup = $(buttonGroup);
      $buttonGroup.on('click', 'li', function () {
        $buttonGroup.find('.is-checked').removeClass('is-checked');
        $(this).addClass('is-checked');
      });
    });

    // Isotope Load more button
    if ($('.image-grid').length) {
      var initShow = 50;
      $('#load-more').hide();
    } else {
      var initShow = 6;
    }
    var counter = initShow;
    var iso = $container.data('isotope');

    loadMore(initShow);

    function loadMore(toShow) {
      $container.find('.hidden').removeClass('hidden');
      var hiddenElems = iso.filteredItems
        .slice(toShow, iso.filteredItems.length)
        .map(function (item) {
          return item.element;
        });
      $(hiddenElems).addClass('hidden');
      $container.isotope('layout');

      //when no more to load, hide show more button
      if (hiddenElems.length == 0) {
        jQuery('#load-more').hide();
      } else {
        jQuery('#load-more').show();
      }
    }

    //append load more button
    if (!$('.image-grid').length) {
      $container.after(
        '<div class="grid-loadmore mt-20 md:mt-30"> <a href="javascript:void(0);" id="load-more" class="button button-border-link mx-auto">Load More Images</a></div>'
      );
    }

    //when load more button clicked
    $('#load-more').click(function () {
      if ($('.filter-button-group').data('clicked')) {
        //when filter button clicked, set initial value for counter
        counter = initShow;
        $('.filter-button-group').data('clicked', false);
      } else {
        counter = counter;
      }

      counter = counter + initShow;

      loadMore(counter);
    });

    //when filter button clicked
    $('.filter-button-group').click(function () {
      $(this).data('clicked', true);
      loadMore(initShow);
    });
  }

  $(document).on('ready', function () {
    function resizeIframe(iframe) {
      iframe.height = iframe.contentWindow.document.body.scrollHeight + 'px';
    }
  });

  // load more posts
  if ($('#post-list-div').length) {
    var ppp = $('#ppp').val();
    var pageNumber = 0;
    loadmore_posts();
  }

  $('body').on('click', '#post-lm-btn a', function () {
    loadmore_posts();
  });

  function loadmore_posts() {
    pageNumber++;
    var activecat_id = '';
    if ($('#ppp').length) {
      activecat_id = $('#activecat_id').val();
    }
    var str =
      '&activecat_id=' +
      activecat_id +
      '&pageNumber=' +
      pageNumber +
      '&ppp=' +
      ppp +
      '&action=more_post_ajax';
    $.ajax({
      type: 'POST',
      dataType: 'html',
      url: ajax_object.ajaxurl,
      data: str,
      success: function (data) {
        var $data = JSON.parse(data);
        if ($data['result'] != '') {
          $('#post-list-div').append($data['result']);
        } else {
          $('#post-list-div').html('<h3>No post found</h3>');
        }
        if ($data['load_more'] == '1' && ppp != '-1') {
          $('#post-lm-btn').show();
        } else {
          $('#post-lm-btn').hide();
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        $('#post-list-div').html('<h3>Something went wrong</h3>');
      },
    });
    return false;
  }
});
